
























































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';

import { createSlug } from '@/helpers/strings';

import PartnerMixin from '@/shared/mixins/PartnerMixin';

import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

@Component({
  components: {
    ScreenSizeVisibility,
  },
})
export default class OfferAuthor extends Mixins(PartnerMixin) {
  @Prop()
  private readonly authors!: any[];

  @Prop()
  private readonly authorName!: string;

  private forceShowTeamPicture: boolean = false;

  @Watch('authorProfileImageUrl')
  onChangePath () {
    this.forceShowTeamPicture = false;
  }

  private get existsAuthors() {
    return this.authors && this.authors.length > 0;
  }

  private get authorProfileImageUrl() {
    let profileImageUrl = '';

    if (this.authors && this.authors.length > 0 && this.authors[0].profile_img_url) {
      profileImageUrl = this.authors[0].profile_img_url;
    } else {
      if (!this.authorName) return '';

      const name = this.authorName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const slug = createSlug(name);

      profileImageUrl = `https://cdn-publifiles-publicacoes.empiricus.com.br/static/authors/${slug}.jpg`;
    }

    return profileImageUrl;
  }

  private get isUniqueAuthor () {
    return this.authors && this.authors.length === 1;
  }

  private get isMobile (): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
